namespace Gamification.Administration {
    export interface UserRoleListResponse extends Serenity.ListResponse<number> {
    }
}

